import { useSessionStore } from '@/entities/session';
import { configureApiAuth, queryClient } from '@/shared/api';

// Connects the shared API client to the session entity without shared importing upward.
configureApiAuth({
  getAccessToken: () => useSessionStore.getState().tokens?.accessToken ?? null,
  onUnauthorized: () => {
    useSessionStore.getState().clearSession();
    queryClient.clear();
  },
});
